import './kp-main-menu-nav.less';
import template from './kp-main-menu-nav.tpl.pug';

import MainMenuComponent from '../main-menu/kp-main-menu.component';

// TODO: load button width from LESS
const BUTTON_WIDTH = 48;

/**
 * @property {MainMenuComponentController} mainMenuController
 */

/**
 * @ngdoc component
 * @name kpMainMenuNav
 * @module portaro.components.main-menu
 *
 * @description
 * Internal component for rendering menu navigation and care about responsivity.
 *
 * # Requires
 * {@link component:kpMainMenu ^^kpMainMenu}
 *
 */
class MainMenuNavComponentController {

    showRightScrollButton = false;
    showLeftScrollButton = false;
    shiftButtonDisabled = false;
    kpOnOverflowApi = {};
    firstVisibleIndex = 0;

    /*@ngInject*/
    constructor($scope, $element) {
        this.$scope = $scope;
        this.$element = $element;
    }

    $postLink() {
        this.$scope.$on('kp.checkOverflowing', this.checkIfOverflowing.bind(this));
    }

    checkIfOverflowing(triggerCallback = true) {
        if (this.kpOnOverflowApi.manualCheck) {
            return this.kpOnOverflowApi.manualCheck(triggerCallback);
        }
    }

    overflow(isOverflowed) {
        this.showRightScrollButton = isOverflowed;
    }

    connectToApi($api) {
        this.kpOnOverflowApi = $api;
    }

    scrollLeft() {
        this.shiftButtonDisabled = true;
        const nav = this.$element[0].querySelector('nav');

        const viewWindowWidth = nav.offsetWidth;

        const elementsWidth = Array.prototype.map.call(nav.querySelectorAll('li.kp-mm-doc-set-nav-tab-container'), (e) => e.offsetWidth);

        let originalOffset = 0;
        for (let i = 0; i < this.firstVisibleIndex; i++) {
            originalOffset = originalOffset + elementsWidth[i];
        }

        // Kdyz je original offset > 0, znamena to, ze je to posunute doleva, tudiz je zobrazeno tlacitko na posun doprava, takze se viewWindow zmensi o 48px
        const correction = originalOffset > 0 ? BUTTON_WIDTH : 0;

        const lastVisibleIndex = this.firstVisibleIndex;

        let currentOffset = 0;
        for (let i = this.firstVisibleIndex; i < elementsWidth.length; i++) {

            this.firstVisibleIndex = i;

            /**
             * Podminka "lastVisibleIndex !== i" zajisti to, ze kdyz se nasledujici element nevejde do okna, tak se stejne prescrolluje
             */
            if (currentOffset + elementsWidth[i] > (viewWindowWidth - correction - BUTTON_WIDTH) && lastVisibleIndex !== i) {
                break;
            }

            currentOffset = currentOffset + elementsWidth[i];
        }

        let restElementsWidth = 0;
        for (let i = this.firstVisibleIndex; i < elementsWidth.length; i++) {
            restElementsWidth = restElementsWidth + elementsWidth[i];
        }

        currentOffset = currentOffset + originalOffset;

        if (currentOffset > 0) {
            currentOffset = currentOffset - BUTTON_WIDTH;
        }

        const ul = nav.querySelector('.kp-mm-doc-set-nav-tab-list');
        ul.style.left = `${0 - currentOffset}px`;

        this.showRightScrollButton = restElementsWidth > (viewWindowWidth - BUTTON_WIDTH);
        this.showLeftScrollButton = true;
    }

    scrollRight() {
        this.shiftButtonDisabled = true;
        const nav = this.$element[0].querySelector('nav');

        const viewWindowWidth = nav.offsetWidth;

        const elementsWidth = Array.prototype.map.call(nav.querySelectorAll('li.kp-mm-doc-set-nav-tab-container'), (e) => e.offsetWidth);

        let originalOffset = 0;
        for (let i = 0; i < this.firstVisibleIndex; i++) {
            originalOffset = originalOffset + elementsWidth[i];
        }

        const correction = originalOffset > 0 ? BUTTON_WIDTH : 0;

        let currentOffset = 0;
        for (let i = this.firstVisibleIndex - 1; i >= 0; i--) {


            // MAGIC!
            if (currentOffset + elementsWidth[i] > viewWindowWidth - correction - BUTTON_WIDTH &&
                !(i === 0 && currentOffset + elementsWidth[0] < viewWindowWidth - BUTTON_WIDTH) && (i !== this.firstVisibleIndex - 1)) {
                this.firstVisibleIndex = i + 1;
                break;
            }

            this.firstVisibleIndex = 0;
            currentOffset = currentOffset + elementsWidth[i];
        }

        currentOffset = originalOffset - currentOffset;

        if (currentOffset > 0) {
            currentOffset = currentOffset - BUTTON_WIDTH;
        }

        const ul = nav.querySelector('.kp-mm-doc-set-nav-tab-list');
        ul.style.left = `${0 - currentOffset}px`;

        this.showRightScrollButton = viewWindowWidth < elementsWidth.reduce((a, cv) => a + cv);
        this.showLeftScrollButton = currentOffset > 0;
    }
}

export default class MainMenuNavComponent {

    static componentName = 'kpMainMenuNav';
    templateUrl = template;
    require = {
        mainMenuController: `^^${MainMenuComponent.componentName}`
    };
    controller = MainMenuNavComponentController;
    controllerAs = 'mmnc';

    constructor() {
    }
}
